import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const { login, isLoginLoading, isLoginSuccess } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoginSuccess) {
      navigate('/');
    }
  }, [isLoginSuccess, navigate]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmailError('');
    setPasswordError('');
    setError('');

    if (!email.trim()) {
      setEmailError('Email is required');
      return;
    }
    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email');
      return;
    }
    if (!password.trim()) {
      setPasswordError('Password is required');
      return;
    }

    login(email, password)
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FCE6D4' }}>
      <div className="flex items-center justify-center md:justify-start px-4 md:pl-32 pt-16 md:pt-32">
        <form onSubmit={handleSubmit} className="space-y-4 w-full max-w-md md:max-w-none">
          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
            <label className="text-base md:text-lg font-medium text-gray-800 md:min-w-[80px]">
              Email
            </label>
            <div className="w-full md:w-80">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={() => {
                  if (!email.trim()) setEmailError('Email is required');
                  else if (!validateEmail(email)) setEmailError('Please enter a valid email');
                  else setEmailError('');
                }}
                className={`px-3 py-2 border bg-white w-full h-10 md:h-8 text-sm ${emailError ? 'border-red-500' : 'border-gray-400'}`}
                disabled={isLoginLoading}
                autoFocus
              />
              {emailError && <div className="text-red-500 text-xs mt-1">{emailError}</div>}
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
            <label className="text-base md:text-lg font-medium text-gray-800 md:min-w-[80px]">
              Password
            </label>
            <div className="flex gap-2 md:gap-4">
              <div className="flex-1 md:w-32">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onBlur={() => {
                    if (!password.trim()) setPasswordError('Password is required');
                    else if (password.length < 6) setPasswordError('Password must be at least 6 characters');
                    else setPasswordError('');
                  }}
                  className={`px-3 py-2 border bg-white w-full h-10 md:h-8 text-sm ${passwordError ? 'border-red-500' : 'border-gray-400'}`}
                  disabled={isLoginLoading}
                />
                {passwordError && <div className="text-red-500 text-xs mt-1">{passwordError}</div>}
              </div>
              <button
                type="submit"
                disabled={isLoginLoading}
                className="px-4 py-2 md:py-1 bg-gray-200 hover:bg-gray-300 border border-gray-400 text-gray-800 text-sm h-10 md:h-8 whitespace-nowrap"
              >
                {isLoginLoading ? 'Logging in...' : 'Log In'}
              </button>
            </div>
          </div>
          
          {error && (
            <div className="text-red-600 text-sm mt-2">
              {error}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login;